/*
 * Cadastro antes do carrinho (snippets/bracci-lead-gate.liquid).
 *
 * Mesmo fluxo do tema antigo (assets/formularios.js): com o carrinho vazio, o
 * primeiro "Adicionar" não adiciona; abre o formulário. Ao enviar:
 *   1. o "Adicionar" original é repetido (botão do Fabric, cartão Bracci...);
 *   2. quando o produto entra no carrinho, os dados vão para a planilha do time de
 *      vendas (Google Apps Script) com o código (token) do carrinho;
 *   3. o carrinho abre como de costume.
 * O pedido volta a aparecer quando o carrinho esvazia ("Sempre que o carrinho estiver
 * vazio"), ou nunca mais neste navegador ("Uma vez por navegador").
 */
(() => {
  // Trava própria: um elemento com id igual ao nome criaria window.BracciLead sozinho.
  if (window.__bracciLeadReady) return;
  window.__bracciLeadReady = true;

  const STORAGE_KEY = 'bracci:lead:sent';
  const ADD_SELECTOR = [
    'form[data-type="add-to-cart-form"] button[name="add"]',
    'product-form-component button[name="add"]',
    '[data-bc-add-button]',
    '.sticky-add-to-cart__button',
    'form[action*="/cart/add"] [type="submit"]',
  ].join(', ');

  let dialog = null;
  let cartCount = 0;
  let pending = null;
  let bypass = false;

  function setup() {
    dialog = document.querySelector('[data-bracci-lead]');
    if (!dialog) return false;
    cartCount = Number(dialog.dataset.cartCount) || 0;
    return true;
  }

  function alreadySent() {
    if (dialog?.dataset.frequency !== 'once') return false;
    try {
      return window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function needsLead() {
    return Boolean(dialog) && cartCount === 0 && !alreadySent();
  }

  /* ---------- Segurar o primeiro "Adicionar" ---------- */

  document.addEventListener(
    'click',
    (event) => {
      if (bypass || !(event.target instanceof Element)) return;
      const button = event.target.closest(ADD_SELECTOR);
      if (!button || button.disabled || button.closest('[data-bracci-lead]')) return;
      if (!dialog && !setup()) return;
      if (!needsLead()) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      pending = button;
      open();
    },
    true
  );

  // Enter dentro do formulário de compra (sem clique no botão)
  document.addEventListener(
    'submit',
    (event) => {
      if (bypass || !(event.target instanceof HTMLFormElement)) return;
      const form = event.target;
      if (form.closest('[data-bracci-lead]')) return;
      const isAdd = form.matches('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
      if (!isAdd) return;
      if (!dialog && !setup()) return;
      if (!needsLead()) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      pending = event.submitter || form.querySelector('button[name="add"], [type="submit"]') || form;
      open();
    },
    true
  );

  /* ---------- Formulário ---------- */

  function open() {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    dialog.querySelector('input[name="nome"]')?.focus();
  }

  function close() {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  function formatPhone(value) {
    const digits = value.replace(/\D/g, '').slice(0, 11);
    if (digits.length > 6) return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
    if (digits.length > 2) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    if (digits.length > 0) return `(${digits}`;
    return '';
  }

  // Mesma validação do tema antigo: DDD sem zero, celular (9 + 8) ou fixo (8), sem número repetido.
  function validPhone(value) {
    const digits = value.replace(/\D/g, '');
    if (/^(\d)\1+$/.test(digits)) return false;
    return /^(?:[1-9]{2})(?:9\d{8}|\d{8})$/.test(digits);
  }

  function repeatAdd() {
    const target = pending;
    pending = null;
    if (!target) return;
    bypass = true;
    try {
      if (target instanceof HTMLFormElement) target.requestSubmit();
      else target.click();
    } finally {
      setTimeout(() => (bypass = false), 0);
    }
  }

  async function waitForCartToken() {
    for (let attempt = 0; attempt < 12; attempt += 1) {
      try {
        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        if (cart.item_count > 0) return cart.token || '';
      } catch (error) {
        /* tenta de novo */
      }
      await new Promise((resolve) => setTimeout(resolve, 500));
    }
    return '';
  }

  function sendLead(data) {
    const webhook = dialog?.dataset.webhook;
    if (!webhook) return;
    waitForCartToken().then((token) => {
      fetch(webhook, {
        method: 'POST',
        mode: 'no-cors',
        body: JSON.stringify({
          nome: data.nome || '-',
          telefone: data.telefone || '-',
          tipo_cliente: data.cliente || '-',
          card_token: token,
          formulario: dialog.dataset.formName || 'Carrinho Abandonado',
          data_envio: new Date().toISOString(),
        }),
      }).catch(() => {});
    });
  }

  document.addEventListener('input', (event) => {
    const input = event.target instanceof HTMLInputElement ? event.target : null;
    if (!input?.matches('[data-bracci-lead-phone]')) return;
    input.value = formatPhone(input.value);
    const error = dialog?.querySelector('[data-bracci-lead-error]');
    if (error && !error.hidden && validPhone(input.value)) {
      error.hidden = true;
      input.removeAttribute('aria-invalid');
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target instanceof Element && event.target.closest('[data-bracci-lead-close]')) {
      pending = null;
      close();
    }
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target instanceof HTMLFormElement ? event.target : null;
      if (!form?.matches('[data-bracci-lead-form]')) return;
      event.preventDefault();

      const phone = form.querySelector('[data-bracci-lead-phone]');
      const error = form.querySelector('[data-bracci-lead-error]');
      const name = form.querySelector('input[name="nome"]');
      const type = form.querySelector('select[name="cliente"]');

      if (!name.value.trim()) {
        name.focus();
        name.reportValidity?.();
        return;
      }
      if (!validPhone(phone.value)) {
        error.hidden = false;
        phone.setAttribute('aria-invalid', 'true');
        phone.focus();
        return;
      }
      if (!type.value) {
        type.focus();
        type.reportValidity?.();
        return;
      }

      const data = Object.fromEntries(new FormData(form).entries());
      try {
        window.localStorage.setItem(STORAGE_KEY, '1');
      } catch (storageError) {
        /* navegação privada */
      }

      cartCount = Math.max(cartCount, 1);
      close();
      form.reset();
      repeatAdd();
      sendLead(data);
    },
    true
  );

  /* ---------- Acompanhar o carrinho ---------- */

  async function watchCart() {
    let eventName = 'cart:lines-update';
    try {
      const events = await import('@shopify/events');
      eventName = events.StandardEvents?.cartLinesUpdate || eventName;
    } catch (error) {
      /* sem importmap */
    }
    document.addEventListener(eventName, (event) => {
      event.promise
        ?.then(({ cart }) => {
          if (cart && typeof cart.totalQuantity === 'number') cartCount = cart.totalQuantity;
        })
        .catch(() => {});
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  watchCart();

  window.BracciLead = { open, needsLead };
})();
